import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import serviceProtocolEsCL from './locales/es-CL.json';
import serviceProtocolEnUS from './locales/en-US.json';
import serviceProtocolPtBR from './locales/pt-BR.json';

export const serviceProtocolI18n = buildScopedI18n({
  esCL: serviceProtocolEsCL,
  enUS: serviceProtocolEnUS,
  ptBR: serviceProtocolPtBR,
});